module.exports = __webpack_public_path__ + "img/brand3.5a70e53f.jpg";